import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const ArchiveDialog = ({ open, stationId, isAdmin, meta, onClose, onChanged }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/fleet/archive", { params: { station_id: stationId } }).then((r) => setRows(r.data));
  useEffect(() => { if (open) load(); }, [open, stationId]); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const reactivate = (v) => act(() => api.post(`/fleet/vehicles/${v.id}/reactivate`), `${v.plate} riattivato`);
  const remove = (v) => window.confirm(`Eliminare DEFINITIVAMENTE ${v.plate}?`) && act(() => api.delete(`/fleet/vehicles/${v.id}`), "Mezzo eliminato");
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-3xl" data-testid="fleet-archive-dialog">
        <DialogHeader>
          <DialogTitle>Storico mezzi disattivati ({rows.length})</DialogTitle>
          <DialogDescription>Mezzi non più in flotta: non rientrano nei conteggi ma restano consultabili.</DialogDescription>
        </DialogHeader>
        <div className="divide-y rounded-lg border">
          {rows.map((v) => (
            <div key={v.id} className="flex flex-wrap items-center gap-3 px-3 py-2.5" data-testid={`archive-row-${v.id}`}>
              <div className="min-w-0 flex-1">
                <p className="text-sm"><span className="font-mono-num rounded-md border border-slate-300 bg-slate-50 px-2 py-0.5 text-xs font-semibold">{v.plate}</span> <span className="text-slate-600">{v.model}</span> <span className="text-xs text-slate-500">· {v.station_name} · {meta.contracts[v.contract_type]}{v.provider && ` · ${v.provider}`}</span></p>
                <p className="mt-1 text-xs text-slate-500">Disattivato il {v.deactivated_at ? new Date(v.deactivated_at).toLocaleDateString("it-IT") : "—"}{v.deactivated_by_name && ` da ${v.deactivated_by_name}`}{v.deactivation_reason && ` · ${v.deactivation_reason}`}</p>
              </div>
              <Button size="sm" variant="outline" onClick={() => reactivate(v)} data-testid={`archive-reactivate-${v.id}`}><RotateCcw className="mr-1 h-4 w-4" /> Riattiva</Button>
              {isAdmin && <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => remove(v)} data-testid={`archive-delete-${v.id}`}><Trash2 className="h-4 w-4" /></Button>}
            </div>
          ))}
          {!rows.length && <p className="p-6 text-center text-sm text-slate-500" data-testid="archive-empty">Nessun mezzo disattivato.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
